import React, { useEffect, useState } from "react";
import { useChromeExtensionDetection } from "hooks";
import AppStore from "./AppStore";

/**
 *  Drive the Chrome extension by providing app store link and reading detection results.
 *
 *  @param {object} props
 *  @returns jsx
 */

const Extension = (props) => {
  /**
   *  Running state consists of:
   *
   *   1. starting - initial detection check.
   *   2. waiting - waiting on app store download and detection run.
   */

  const [state, setState] = useState({ starting: true });

  // const isStartingState = () => {
  //   return state.starting;
  // };

  // console.log("rerendered");

  const ss = () => {
    // setTimeout(() => {
    //setState({ waiting: true });

    if (!state.waiting) {
      //    console.log("updateing state");
      setState({ waiting: true });
    }

    //});
  };

  /**
   * Detection done handler cleans up and moves on.
   *
   * @param {object} evt - Event info
   */
  const onDetectionDone = (evt) => {
    // console.log("evt");

    if (evt.success) {
      // console.log("evt x");
      // The detection was successful, so call the done event handler in the parent.
      props.onDone(evt);

      //setState();
      // else {
      //   setState({ waiting: true });
      // }

      // } else if (state.starting) {
      //   console.log("evt xx");
      //   // This was the first attempt at detection, so set the state to wait and continue polling the detection.
      //   setState({ waiting: true });
    }
    //ss();
  };

  // The detection library hook.
  const runChromeExtensionDetection = useChromeExtensionDetection(
    null,
    onDetectionDone
  );

  // Initial call to the detection library.
  useEffect(
    () => {
      //setState({ starting: true });
      // setState({ waiting: true });

      // Fire up the extension, if it even exists, by sending it an event. Might cause other browser tabs to be activated.
      document.dispatchEvent(
        new Event("srlrun", {
          bubbles: true,
          cancelable: false,
        })
      );

      runChromeExtensionDetection(); // Make the initial call to the detection library.

      let timerID = setInterval(() => {
        runChromeExtensionDetection();

        // if (state.starting) {
        console.log("updating the state to waiting");
        setState((state) => ({
          waiting: true,
        }));
        //}
      }, 2000);

      // Set a timeout timer.
      let timeOutID = setTimeout(() => {
        clearInterval(timerID);
        props.onDone({ success: false, error: { id: "TimeoutError" } });
      }, 60000);

      return () => {
        // console.log("clearing");
        clearTimeout(timeOutID);
        clearInterval(timerID);
      };
    },
    [] // Only once at startup.
  );

  // The rendering.
  return <>{state.waiting && <AppStore />}</>;
};

export default Extension;
